import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerPortalService } from '../../services/customer-portal.service';
import * as jsPDF from 'jspdf';
import { CustomerPortal } from '../../models/customer-portal';
import { getrelativeurl } from '../../../../../environments/environment';
import html2canvas from 'html2canvas';
import { LayoutType } from '../../models/layout-type';

@Component({
  selector: 'app-customer-portal-view',
  templateUrl: './customer-portal-view.component.html',
  styleUrls: ['./customer-portal-view.component.css']
})
export class CustomerPortalViewComponent implements OnInit {

  dialog:any;
  offer:CustomerPortal;
  layoutType:LayoutType;
  public isGenerating = false;

  constructor(
    private dialogRef: MatDialogRef<CustomerPortalViewComponent>,
    private customerPortalService:CustomerPortalService,
    @Inject(MAT_DIALOG_DATA) data ) {
    this.dialog = data;
   }

  ngOnInit() {
    if(this.dialog && this.dialog.id){
      this.customerPortalService.Get(this.dialog.id).subscribe(result => {
        if(result){
          this.offer = result.payload;
          if(this.offer){
            if(this.offer.plasardLayoutSubType){
              this.layoutType = this.offer.plasardLayoutSubType
            }
            else if(this.offer.plasardLayoutType){
              this.layoutType = this.offer.plasardLayoutType;
            }
          }
        }
      })
    }
  }
  cancel(){
    this.dialogRef.close();
  }
  confirm(){
    this.dialogRef.close(true);
  }
  generatePdf(){            

    let doc = new jsPDF("p", "mm", "a4",1);

    let div = document.getElementById("pdfLayoutLeft");    
    let options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};
    
    this.isGenerating = true;

    let pages = [];
    let pagesImages:Map<string, any> =  new Map<string, any>();

    if(div){
      console.log('pdfLayoutLeft', div);        
      let pageLeft = html2canvas(div, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1);
          pagesImages.set('left',imgData);
      });      
      pages.push(pageLeft);
    }



    div = document.getElementById("pdfLayoutCenter");    
    console.log('pdfLayoutCenter', div);        
    if(div){
      options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};    
      let pageCenter = html2canvas(div, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1);
          pagesImages.set('center',imgData);
      });   
      pages.push(pageCenter);
    }   

    div = document.getElementById("pdfLayoutRight");            
    console.log('pdfLayoutRight', div); 
    if(div){
      options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};    
      let pageRight = html2canvas(div, options).then((canvas) => {        
        
          let imgData = canvas.toDataURL("image/jpeg", 1);
          pagesImages.set('right',imgData);
      });   
      pages.push(pageRight);
    }         

    div = document.getElementById("pdfOffer");            
    if(div){
      options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};    
      let pageOffer = html2canvas(div, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1);
          pagesImages.set('offer',imgData);
      });   
      pages.push(pageOffer);
    }    
    Promise.all(pages).then(value => {
      let pp = 0;
      if(pagesImages.has('left')){
        this.addPage(doc,pp,pagesImages.get('left'));
        pp++;
      }
      if(pagesImages.has('center')){
        this.addPage(doc,pp,pagesImages.get('center'));
        pp++;
      }
      if(pagesImages.has('right')){
        this.addPage(doc,pp,pagesImages.get('right'));
        pp++;
      }      
      if(pagesImages.has('offer')){
        this.addPage(doc,pp,pagesImages.get('offer'));
        pp++;
      }            

          let pdfOutput = doc.output();
          

          // using ArrayBuffer will allow you to put image inside PDF
          let buffer = new ArrayBuffer(pdfOutput.length);
          let array = new Uint8Array(buffer);
          for (let i = 0; i < pdfOutput.length; i++) {
              array[i] = pdfOutput.charCodeAt(i);
          }

          //Name of pdf
          const fileName = `ponudba-${this.offer.code}.pdf`;
          // Make file
          doc.save(fileName);
          this.isGenerating = false;
    });

  }
  addPage(doc:any,page:number,data:any){
    var position = 0;
    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();            
    if(data){
      if(page > 0){
        doc.addPage("a4","p");
        doc.setPage(page+1);
      }
      doc.addImage(data, 'JPEG', 0, position, width-20, height,undefined,'SLOW');
    }     
  }
  assets(file:string){
    return getrelativeurl(`assets/${file}`);
  }  
}
